import type { LiveEffectEvent } from '../../api/payment/live-effect.api';

/** Số id gần nhất giữ lại để bỏ trùng; overlay để mở cả buổi live không phình bộ nhớ mãi. */
export const MAX_SEEN_IDS = 500;

/** Hàng đợi tuần tự của overlay: bỏ trùng theo triggerId (đẩy realtime + lấy bù khi nối lại có thể trùng). */
export class EffectQueue {
  private items: LiveEffectEvent[] = [];

  /** Set giữ thứ tự thêm vào: phần tử đầu là id cũ nhất, bị bỏ trước khi vượt trần. */
  private seen = new Set<string>();

  private readonly maxSeen: number;

  constructor(maxSeen = MAX_SEEN_IDS) {
    this.maxSeen = maxSeen;
  }

  get size() {
    return this.items.length;
  }

  push(ev: LiveEffectEvent): boolean {
    if (ev.kind !== 'play' || !ev.triggerId || this.seen.has(ev.triggerId))
      return false;
    this.remember(ev.triggerId);
    this.items.push(ev);
    return true;
  }

  shift(): LiveEffectEvent | undefined {
    return this.items.shift();
  }

  /** Đánh dấu đã chạy để lần lấy bù sau không chạy lại (đưa id lên mới nhất để không bị bỏ sớm). */
  markDone(id: string) {
    this.remember(id);
  }

  private remember(id: string) {
    this.seen.delete(id);
    this.seen.add(id);
    while (this.seen.size > this.maxSeen) {
      const oldest = this.seen.values().next().value as string;
      this.seen.delete(oldest);
    }
  }
}
